const quickLinks = [
  { label: "Ana Sayfa", href: "#hero" },
  { label: "Hakkımızda", href: "#hakkimizda" },
  { label: "Projeler", href: "#projeler" },
  { label: "Ekibimiz", href: "#ekip" },
  { label: "Hizmetler", href: "#hizmetler" },
  { label: "İletişim", href: "#iletisim" },
];

const contactInfo = [
  { icon: "ri-map-pin-2-line", text: "Ankara, Türkiye" },
  { icon: "ri-phone-line", text: "+90 532 136 79 81" },
  { icon: "ri-mail-line", text: "info@guvenlidizayn.com" },
];

const socials = [
  { icon: "ri-whatsapp-line", href: "https://wa.me/905321367981", label: "WhatsApp" },
  { icon: "ri-instagram-line", href: "https://www.instagram.com/guvenlidizayn/", label: "Instagram" },
  { icon: "ri-linkedin-line", href: "https://www.linkedin.com/company/g%C3%BCvenli-dizayn", label: "LinkedIn" },
];

import { useLocation, useNavigate } from "react-router-dom";

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (href: string) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: href } });
    } else {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-[#1A2B4A] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <img
              src="/images/logo.png"
              alt="Güvenli Dizayn Logo"
              className="h-12 w-auto object-contain mb-5 brightness-0 invert"
            />
            <p className="text-white/60 text-sm leading-relaxed mb-6 max-w-xs">
              2004'ten bu yana genel müteahhitlik alanında güvenilir çözümler sunuyoruz. Türkiye genelinde 33+ tamamlanan proje.
            </p>
            <div className="flex gap-3">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-[#4CAF50] hover:border-[#4CAF50] transition-colors duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-base mb-5">Hızlı Linkler</h4>
            <ul className="flex flex-col gap-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => handleNavClick(link.href)}
                    className="text-white/60 text-sm hover:text-[#4CAF50] transition-colors duration-200 cursor-pointer flex items-center gap-2 whitespace-nowrap"
                  >
                    <i className="ri-arrow-right-s-line text-[#4CAF50]" />
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-base mb-5">İletişim</h4>
            <ul className="flex flex-col gap-4">
              {contactInfo.map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#4CAF50]/15 flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-[#4CAF50] text-sm`} />
                  </div>
                  <span className="text-white/60 text-sm leading-relaxed">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">
            © 2026 Güvenli Dizayn Dekorasyon. Tüm hakları saklıdır.
          </p>

        </div>
      </div>
    </footer>
  );
}
